import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { User } from '../../../reservation.model';
import { debounceTime, map, startWith } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReservationSummaryApiService } from '../../services/reservation-summary-api.service';
import { InfoboxService } from '../../../../common/infobox/infobox.service';

@Component({
	selector: 'app-reservation-summary-guide-dialog',
	templateUrl: './reservation-summary-guide-dialog.component.html',
	styleUrls: ['./reservation-summary-guide-dialog.component.scss'],
})
export class ReservationSummaryGuideDialogComponent implements OnInit {
	usersSelect = new FormControl('');
	filteredUsers: User[];
	selectedUser: number = null;
	constructor(
		public dialogRef: MatDialogRef<ReservationSummaryGuideDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: { users: User[]; resId: number },
		private readonly api: ReservationSummaryApiService,
		private readonly infobox: InfoboxService,
	) {}

	ngOnInit() {
		this.filteredUsers = this.data.users;
		this.usersSelect.valueChanges
			.pipe(
				startWith(''),
				debounceTime(400),
				map((value) => this._filterUsers(value || '')),
			)
			.subscribe((filtered) => {
				this.filteredUsers = filtered;
			});
	}

	_filterUsers(value: string) {
		if (value && typeof value === 'string') {
			const filterValue = value.toLowerCase();

			if (filterValue.length < 3) return this.data.users;

			return this.data.users.filter(
				(option) =>
					option.firstName.toLowerCase().includes(filterValue) ||
					option.lastName.toLowerCase().includes(filterValue),
			);
		}

		return this.data.users;
	}

	protected displayUsersFn(user: User | number): string {
		return user && typeof user === 'number'
			? `${this.data.users.find((v) => v.id === user).firstName} ${
					this.data.users.find((v) => v.id === user).lastName
				}`
			: '';
	}

	selectUser($event: MatAutocompleteSelectedEvent) {
		this.selectedUser = $event.option.value;
	}

	submit(user: FormControl) {
		const { updateResponsibleUser } = this.api.actions();
		updateResponsibleUser(user.value, this.data.resId).then(() => {
			this.infobox.success('Pomyślnie zmieniono opiekuna');
			this.dialogRef.close(true);
		});
	}
}
